// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (C) 2024 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

.not-found-page-shell {
  background-color: #F4EFE7;
  display: flex;
  flex-direction: column;
}

.not-found-page-layout {
  box-sizing: border-box;
  flex: 1;
  padding: 86px clamp(16px, 12vw, 240px);
  width: 100%;
}

.not-found-page-card-layout-item {
  max-width: 568px;
  min-width: 0;
  width: 100%;
}

.not-found-page-content-layout {
  align-items: flex-start;
  text-align: left;
  width: 100%;
}

.not-found-page-card-content {
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  padding: 32px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

@media (max-width: 640px) {
  .not-found-page-layout {
    padding: 48px 24px;
  }
}

@media (max-width: 480px) {
  .not-found-page-layout {
    padding: 32px 16px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/NotFoundPage/NotFoundPage.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/*\n * Copyright (C) 2024 JPMorgan Chase & Company\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, is not permitted.\n */\n\n.not-found-page-shell {\n  background-color: #F4EFE7;\n  display: flex;\n  flex-direction: column;\n}\n\n.not-found-page-layout {\n  box-sizing: border-box;\n  flex: 1;\n  padding: 86px clamp(16px, 12vw, 240px);\n  width: 100%;\n}\n\n.not-found-page-card-layout-item {\n  max-width: 568px;\n  min-width: 0;\n  width: 100%;\n}\n\n.not-found-page-content-layout {\n  align-items: flex-start;\n  text-align: left;\n  width: 100%;\n}\n\n.not-found-page-card-content {\n  background-color: #fff;\n  border-radius: 16px;\n  border: 1px solid #d8d8d8;\n  box-sizing: border-box;\n  padding: 32px 16px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n@media (max-width: 640px) {\n  .not-found-page-layout {\n    padding: 48px 24px;\n  }\n}\n\n@media (max-width: 480px) {\n  .not-found-page-layout {\n    padding: 32px 16px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
